// src/main.jsx
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from '@/utils/sentry'
import './i18n'
import App from './App.jsx'
import InternalGate from './pages/InternalGate'
import ComingSoon from './pages/ComingSoon';
import './index.css'

// Initialize Sentry before rendering
initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {import.meta.env.VITE_COMING_SOON === 'true' ? <ComingSoon /> : <InternalGate><App /></InternalGate>}
  </StrictMode>
)
